/*    
<summary>
   This file is used to provide initial values or state to the User Data observables.
   Developer:Ashish Singh, Created Date: 29-August-2023
</summary>
*/

import { IAddStoreManagement } from "../../models/forms/IAddStore";


export const initialState: IAddStoreManagement = {
  StoreName: "",
  StoreCode: "",
  BusinessTypeId: -1,
  MobileNumber: "",
  Email: "",
  Password: "",
  ConfirmPassword: "",
  PrefectureName: "",
  PostalCode: "",
  StoreOwnerName: "",
  Address: "",
  Url: "",
  KanaName: "",
  Status: "1",
  IsNominationFee: "1",
  StoreCategory: "0",
  StoreLink: "",
  Image: "",
  ThumbnailImage: "",
  HeadquarterId: null,
}